import angular from 'angular';
import _ from 'underscore';
'use strict';
angular.module('emun.consumer').directive('refundOrderPrompt', RefundOrderPromptDirective);

function RefundOrderPromptDirective($window, $parse, refundOrderPrompt) {
    // Introduce custom elements for IE8
    $window.document.createElement('refund-order-prompt');
    return {
        scope: false,
        link: function (scope, element, attr) {
            var onOrderRefunded = attr.onOrderRefunded || attr.onOrderRefunded;

            var $targets = (attr.refundOrderPromptClickSelector ? element.find(attr.refundOrderPromptClickSelector) : element);
            $targets.on('click', e => {
                var model = scope.$eval(attr.refundOrderPrompt || attr.ngModel || attr.order || attr.cart) || {
                    cartId: attr.orderNumber || attr.cartId || attr.id,
                    amount: attr.amount
                };
                refundOrderPrompt.open({ title: attr.title, scope, attr, element, $targets, model }).then(
                    (saved) => {
                        if (onOrderRefunded) {
                            $parse(onOrderRefunded)(scope, { $saved: saved })
                        }
                    }, () => {
                        if (attr.onDismissed) {
                            $parse(attr.onDismissed)(scope, {})
                        }
                    });
            });
        }
    }
};